import { useTranslation } from "react-i18next";
import { getPlayerRole } from "../../utils/players";
import PlayerImage from "../ui/PlayerImage";
import MyDrawer from "../ui/Drawer";
import { Team } from "../../types";
import { COMMON_TRANSLATE_KEYS } from "../../constants/translate-keys";

import LocationIcon from '../../icons/svg/location.svg';

type Props = {
  team: Team;
  drawerOpen: boolean;
  handleCloseDrawer: () => void;
  onPlayerClick: (player: Team["players"][0]) => void;
};

const TeamDrawer = ({ onPlayerClick, drawerOpen, handleCloseDrawer, team }: Props) => {
  const { t } = useTranslation();

  return (
    <MyDrawer isOpen={drawerOpen} onClose={handleCloseDrawer}>
      <div className="h-full overflow-y-auto">
        <div className="flex justify-end">
          <button
            onClick={handleCloseDrawer}
            className="text-white py-5"
            type="button"
          >
            X
          </button>
        </div>
        <div className="bg-additionalBlack rounded-lg h-full">
          <div className="flex">
            {team.logoUrl ? (
              <img
                src={team.logoUrl}
                alt="Team"
                className="object-cover w-full h-[240px] rounded-lg"
              />
            ) : (
              <div className="w-full h-[240px] rounded-lg border-4 border-dividerGray"></div>
            )}
          </div>
          <div className="flex flex-col p-3 gap-2">
            <p className="font-inter text-2xl not-italic font-bold leading-7 mb-3 border-0 bg-transparent text-start">
              {`${t(COMMON_TRANSLATE_KEYS.TEAM).toLowerCase()} ${team.name}`}
            </p>
            <div>
              {team.city && (
                <div className="flex flex-row items-center gap-1">
                  <span className="flex gap-1">
                    <img src={LocationIcon} alt="Location" />
                    {/* {`${t(COMMON_TRANSLATE_KEYS.ADDRESS)}:`} */}
                  </span>
                  <span>
                    <p>{team.city}</p>
                  </span>
                </div>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-mainBlue">
                {t(COMMON_TRANSLATE_KEYS.CAPTAIN)}:{' '}
                <span className="text-white">{team.captain.name}</span>
              </p>
            </div>
            {team.secondCaptain && (
              <div className="flex flex-row gap-2">
                <p className="text-mainBlue">
                  {t(COMMON_TRANSLATE_KEYS.SECOND_CAPTAIN)}:{' '}
                  <span className="text-white">{team.secondCaptain.name}</span>
                </p>
              </div>
            )}
            {team.info && (
              <div className="flex flex-row gap-1">
                <span className="text-mainBlue text-start">
                  {`${t(COMMON_TRANSLATE_KEYS.INFO)}:`}
                </span>
                <span className="text-white">{team.info}</span>
              </div>
            )}
          </div>
          <div className="mt-4 mb-8 p-4">
            <div className="flex flex-row justify-between">
              <p className="text-lg font-semibold">
                {t(COMMON_TRANSLATE_KEYS.PLAYERS, { count: 2 })}
              </p>
            </div>
            <div className="grid grid-cols-4 gap-4 mt-4">
              {team.players.map((player, index) => (
                <PlayerImage
                  key={index}
                  name={player.name}
                  role={getPlayerRole(player, team)}
                  imageUrl={player.imageUrl}
                  onClick={() => onPlayerClick(player)}
                  hidden={false}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </MyDrawer>
  );
};

export default TeamDrawer;
